<template>
  <div class="index-container" ref="ref_scoll">
    <f-header />
    <div class="fateBanner-container">
      <div class="main fateBoxBanner">
        <div class="fateBox">
          <ul class="fateLeft">
            <li class="wow fadeInUp wow_show">APS智能排程系统</li>
            <li class="wow fadeInUp wow_show">智能排产帮手，从源头上确保交期，降低成本，提升管理</li>
            <li class="wow fadeInUp wow_show">
              点击获取方案
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="control-container">
      <div class="netFate-title">
        <p class="wow fadeInUp">延期交付率高，生产无序不可控？</p>
      </div>
      <ul class="controlUl main">
        <li class="wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.2s">
          <img src="https://oss.cloudcpc.com/aps_menu01.png" alt="">
          <p>手工生产计划粗略、误差大，生产混乱</p>
        </li>
        <li class="wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.4s">
          <img src="https://oss.cloudcpc.com/aps_menu02.png" alt="">
          <p>产能无法均衡分配，急单做不出，大单做不了</p>
        </li>
        <li class="wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.6s">
          <img src="https://oss.cloudcpc.com/aps_menu03.png" alt="">
          <p>计划赶不上变化，生产背离实际</p>
        </li>
        <li class="wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.8s">
          <img src="https://oss.cloudcpc.com/aps_menu04.png" alt="">
          <p>前后工序间刻板作业，联动极其困难</p>
        </li>
      </ul>
    </div>

    <div class="touch-container">
      <div class="netFate-title nettOne">
        <p class="wow fadeInUp">一键式智能优化排程</p>
        <h5 class="wow fadeInUp">APS智能排程系统是一种基于供应链管理和约束理论的先进计划与排产软件系统。它通过同步考虑多种有限能力资源的约束，依据各种<br>预设规则，通过非常复杂的智能化算法，反复模拟、优化、计算，最终给出最优的详细计划。</h5>
      </div>
      <div class="touchDivOne main wow fadeInUp">
        <img src="https://oss.cloudcpc.com/aps_suss.png" alt="">
      </div>
      <div class="netFate-title nettTwo">
        <h5 class="wow fadeInUp">APS可以实现业务流程规范化，打通ERP系统、生产、成本、应收应付等各个环节，实时掌握企业现状。同时，借助条码管理和合理的生<br>产规划，实现清晰库存、减少重复投单，降低存货压力。</h5>
      </div>

      <div class="touchDivTwo main wow fadeInUp">
        <img src="https://oss.cloudcpc.com/aps_kao1.png" alt="">
      </div>
    </div>

    <div class="feater-container">
      <div class="netFate-title">
        <p class="wow fadeInUp">系统功能特点</p>
      </div>
      <ul class="featerUlOne main">
        <li class="featerLi wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.2s">
          <h3>产能配置</h3>
          <p>生产日历，维护车间产线工时
            标准工时产能，为产能做依据
            设备、机台、人力等产能确认</p>
          <img src="https://oss.cloudcpc.com/aps_01.png" alt="">
        </li>
        <li class="featerLi wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.4s">
          <h3>可视化模块排产</h3>
          <p>同步ERP，确保物料供应，快速排定月生产计划<br>通过产能校验，产前确认，快速排定周/日生产计划<br>一个计划变更，相关计划自动调整，快速联动反应</p>
          <img src="https://oss.cloudcpc.com/aps_02.png" alt="">
        </li>
        <li class="featerLi wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.6s">
          <h3>产能配置</h3>
          <p>对选择的工单进行快速的物料齐套分析，有序排产<br>产前确认，有变更时自动触发预警，保障工单生产</p>
          <img src="https://oss.cloudcpc.com/aps_03.png" alt="">
        </li>
      </ul>

      <div class="featerDiv">
        <div class="nettThr wow fadeInUp">
          <img src="https://oss.cloudcpc.com/aps_04.png" alt="">
          <span>计划闭环<i>： 实时采集生产过程数据，与生产计划形成有效闭环</i></span>
        </div>
        <div class="featerImg">
          <div class="main wow fadeInUp">
            <img src="https://oss.cloudcpc.com/aps_plan.png" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="intell-container">
      <div class="netFate-title nettFour">
        <p class="wow fadeInUp">一键式智能优化排程</p>
        <h5 class="wow fadeInUp">数智邦APS智能排程系统是一种基于供应链管理和约束理论的先进计划与排产软件系统。它通过同步考虑多种有限能力资源的约束，依据<br>各种预设规则，通过非常复杂的智能化算法，反复模拟、优化、计算，最终给出最优的详细计划。</h5>
      </div>
      <ul class="intellUl main">
        <li class="wow fadeInUp">
          <p>需求预测和订单承诺闭环</p>
        </li>
        <li class="wow fadeInUp">
          <p>计划与排产闭环</p>
        </li>
        <li class="wow fadeInUp">
          <p>排产与执行闭环</p>
        </li>
        <li class="wow fadeInUp">
          <p>订单承诺与履约闭环</p>
        </li>
        <li class="wow fadeInUp">
          <p>履约发货</p>
        </li>
      </ul>
      <div class="intellImg main wow fadeInUp">
        <img src="https://oss.cloudcpc.com/aps_ju.png" alt="">
      </div>
    </div>

    <div class="aspect-container netFate-title">
      <p class="wow fadeInUp">从多方面降低生产运营成本</p>
      <ul class="aspectUl main">
        <li class="aspectLi wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.2s">
          <h3>降低设备成本</h3>
          <p>充分利用设备产能，减少停机换产损失。<br>
            提高设备利用率，让最合适的设备生产最合适的订单。</p>
          <img src="https://oss.cloudcpc.com/aps_shebe1.png" alt="">
        </li>
        <li class="aspectLi wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.4s">
          <h3>降低物料成本</h3>
          <p>按需采购，减少长期采购资金的占用。<br>
            减少物料库存积压，提高仓位利用率，降低库存成本。</p>
          <img src="https://oss.cloudcpc.com/aps_shebe1.png" alt="">
        </li>
        <li class="aspectLi wow fadeInUp" data-wow-duration="0.4s" data-wow-delay="0.6s">
          <h3>降低人力成本</h3>
          <p>大幅减少计划人员的工作量70%-95%<br>
            减少订单跟单人员数量；生产间接人员数量；减少车间现场搬运人员数量；减少仓库备料人员数量</p>
          <img src="https://oss.cloudcpc.com/aps_shebe1.png" alt="">
        </li>
      </ul>
    </div>

    <div class="footer-container">
      <div class="main footTan">
        <div class="footDiv">
          <p>高效排产</p>
          <span></span>
          <p>精准交付</p>
        </div>
        <ul class="footUl">
          <li>提高排产效率和可执行率，提高生产效率</li>
          <li>高效调整，快速响应急单、插单、合并等变化</li>
          <li>产前齐套确认，产能科学分配</li>
          <li>精准供应提升库存周转率、精准交付提升客户满意度</li>
          <li>实时透明生产、生产计划智能调度</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
// import Swiper from 'swiper'
import { WOW } from "wowjs";

export default {
  data() {
    return {
      swiperOption: {
        pagination: ".swiper-pagination",
        paginationClickable: true,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        // loop: true,
        //autoplay: 4000,
        autoplayDisableOnInteraction: false,
      },
    };
  },
  beforeDestroy() {
    $("#bangId").removeClass("on active").removeAttr("aria-current", "page");
  },
  mounted() {
    $("#bangId").addClass("on active").attr("aria-current", "page");
    /** SEO start */
    // seo_title
    document.getElementById("seo_title").innerHTML =
      "APS-智能排程系统-国机集团武汉纺友";
    // seo_keywords
    document.getElementById("seo_keywords").content =
      "智能排程系统,订单计划,自动排产";
    // seo_description
    document.getElementById("seo_description").content =
      "先进计划与排产软件系统，通过同步考虑多种有限能力资源的约束，依据各种预设规则，通过智能化算法，最终给出最优的详细计划。从源头上确保订单按期交付，降低生产成本，提升企业管理。";
    /** SEO end */
    this.$nextTick(() => {
      let wow = new WOW({
        boxClass: "wow", /// 动画元件css类（默认为wow）
        animateClass: "animated", // 动画css类（默认为animated）
        offset: 0, // 到元素距离触发动画（当默认为0）
        mobile: true, // 在移动设备上触发动画（默认为true）
        live: true, // 对异步加载的内容进行操作（默认为true）
      });
      // wow.start()
      wow.init();
      if (document.getElementsByClassName("wow_show").length > 0) {
        if (window.scrollY !== 0) return;
        for (
          let index = 0;
          index < document.getElementsByClassName("wow_show").length;
          index++
        ) {
          wow.show(document.getElementsByClassName("wow_show")[index]);
        }
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "assets/style/aps.scss";
/deep/.inSwiperPage {
  bottom: 40px;
  .swiper-pagination-bullet {
    width: 15px;
    height: 15px;
    background: #a4a4a5;
  }
  .swiper-pagination-bullet-active {
    background: #0171ff;
  }
}
</style>
